import React, { useEffect, useMemo, useState } from 'react'
import { GraviGrid, NetValueCell, NumberCell, PriceDifferenceCell } from '@gravitate-js/excalibrr'
import { useUserSettings } from '@hooks/settings'

export const PriceLoadedGrid = ({ priceMetrics, metricsLoading }) => {
  const [loadedData, setLoadedData] = useState([])
  const { updateSetting } = useUserSettings()

  useEffect(() => {
    if (priceMetrics) {
      setLoadedData([...priceMetrics.volumes])
    }
  }, [priceMetrics])

  const agPropOverrides = useMemo(
    () => ({
      frameworkComponents: {
        numberCell: NumberCell,
        priceDifferenceCell: PriceDifferenceCell,
        netValueCell: NetValueCell,
      },
      rowHeight: 30,
    }),
    []
  )
  const columnDefs = useMemo(() => getColumnDefs(), [])
  return (
    <GraviGrid
      storageKey='priceLoaded'
      loading={metricsLoading}
      rowData={loadedData}
      agPropOverrides={agPropOverrides}
      columnDefs={columnDefs}
      onGridConfigChanged={(config) => updateSetting('gridConfig::priceLoaded', config)}
    />
  )
}
const getColumnDefs = () => [
  {
    headerName: 'Date',
    field: 'date',
  },
  {
    headerName: 'Loaded',
    field: 'loaded',
    cellRenderer: 'numberCell',
    cellRendererParams: { weight: 'bold' },
  },
  {
    headerName: 'Directive Loaded',
    field: 'total_directive',
    cellRenderer: 'numberCell',
  },
  {
    headerName: 'Net Value',
    field: 'cost_difference',
    cellRenderer: 'netValueCell',
  },
  {
    flex: 2,
    headerName: 'Price',
    field: 'price',
    cellRenderer: 'priceDifferenceCell',
    cellRendererParams: { comparisonKey: 'price_difference', precision: 4 },
  },
]
